import { X } from "lucide-react";
import { useState } from "react";
import type { StoryItem } from "../../shared/types";

export function Stories({ stories }: { stories: StoryItem[] }) {
  const [active, setActive] = useState<number | null>(null);
  const story = active == null ? null : stories[active];
  return (
    <>
      <section className="stories" aria-label="Stories">
        {stories.map((item, index) => (
          <button key={item.id} onClick={() => setActive(index)} className={item.viewed ? "story viewed" : "story"}>
            <span><img src={item.user.avatarUrl} alt="" /></span>
            <em>{item.user.username}</em>
          </button>
        ))}
      </section>
      {story && (
        <div className="story-viewer" role="dialog" aria-modal="true">
          <div className="story-progress">{stories.map((_, index) => <i key={index} className={index <= active! ? "filled" : ""} />)}</div>
          <header><img src={story.user.avatarUrl} alt="" /><strong>{story.user.displayName}</strong><button onClick={() => setActive(null)} aria-label="Close story"><X /></button></header>
          <button className="story-zone prev" onClick={() => setActive(Math.max(0, active! - 1))} aria-label="Previous story" />
          <img src={story.mediaUrl} alt={story.caption} />
          <button className="story-zone next" onClick={() => active! < stories.length - 1 ? setActive(active! + 1) : setActive(null)} aria-label="Next story" />
          <p>{story.caption}</p>
        </div>
      )}
    </>
  );
}
